import React, {
    useContext,
    useState,
    useEffect
} from 'react';
import {
    AsgAppContext,
    AsgDictionaryContext
} from '../../contexts';
import { GameImprovementsWrap } from '../GameImprovementsWrap/GameImprovementsWrap';
import starsRightImg from '../../../images/stars-right.svg';

export const GameImprovementsOverly = ({ gamesListItem, onMobile }) => {
    const dictionary = useContext(AsgDictionaryContext);
    const AsgApp = useContext(AsgAppContext);

    const [showWalkThrough, setShowWalkThrough] = useState(false);

    useEffect(() => {
        if (AsgApp.isShowWalkThrough()) {
            setShowWalkThrough(true);
        }
    }, [AsgApp.isShowWalkThrough()]);

    const handleWalkThroughSkipClicked = () => {
        if (showWalkThrough) {
            setShowWalkThrough(false);
            AsgApp.setCookieWalkThroughStatus();
        }
    };

    return (
        <div className="game-improvements-component-overly" onClick={handleWalkThroughSkipClicked}>
            <div id="game-improvements-component" className="game-improvements-wrap">
                {showWalkThrough && <div className="walk-through-wrap">
                    <div className="walk-through-content">
                        {dictionary.translate('walkThroughContent2')}
                        <img src={starsRightImg} alt="" className="walk-through-content__img" />
                    </div>
                </div>}
                <GameImprovementsWrap gamesListItem={gamesListItem} onMobile={onMobile}/>
            </div>
        </div>
    );
};
